<!--
 Copyright 2022 Carnegie Mellon University. All Rights Reserved. 
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<comn-header-bar></comn-header-bar>
<!--
  The routed page is the document's main landmark. Without one, assistive technology has no
  way to skip past the toolbar to the content: every route was previously a flat sequence of
  divs. app-main carries the flex layout the routed component's :host expects (flex: 1 in a
  column), so this wrapper is layout-neutral.
-->
<main class="app-main">
  <router-outlet></router-outlet>
</main>

